// 通用工具:测距、测面、鼠标位置、添加百度街景图层、实时交通图层
const componentBase = (G as any).base.ComponentBase;
const component = componentBase.extend({
    // 属性
    options: {
        map: null,
        bdPanoCtrl: null,
        panoCoverageLayer: null,
        config: null,
        TencentPanoCtrl: null,
        TencentpanoCoverageLayer: null,
    },

    // 初始化
    initialize(options: any) {
        componentBase.prototype.initialize.call(this, options);
    },
    //  销毁
    destroy() {
        componentBase.prototype.destroy.call(this);
    },

    unload() {
        componentBase.prototype.unload.call(this);
        this.removebduLayerCtro();
        this.removeTencentLayerCtro();
    },

    // 添加百度全景图层与按钮到地图
    addbdLayerCtol() {
        this.options.panoCoverageLayer = this._initPanoCoverageLayer(); // 初始化
        this.options.bdPanoCtrl = this._initbdPanoCtrl(this.map); // 初始化控件
        this.map.addLayer(this.options.panoCoverageLayer); // 添加图层
        this.map.addPanoramaControl(this.options.bdPanoCtrl); // 添加控件
        this.options.bdPanoCtrl.controlClickFun();
    },

    // 添加腾讯全景图层与按钮到地图
    addTencentLayerCtol() {
        this._initTencentPanoCoverageLayer(); // 初始化
        this._initTencentPanoCtrl(); // 初始化控件
        this.map.addLayer(this.options.TencentpanoCoverageLayer); // 添加图层
        this.map.addPanoramaControl(this.options.TencentPanoCtrl); // 添加控件
        this.options.TencentPanoCtrl.controlClickFun();
    },
    // 初始化腾讯全景覆盖图层
    _initTencentPanoCoverageLayer() {
        this.options.TencentpanoCoverageLayer = new g2.carto.TencentLayer({
            name: '腾讯全景覆盖图层',
            id: 'tencentPanoCoverageLayer',
            type: 3,
            crossOrigin: null, // 不跨域处理，服务端已做跨域处理。
            url: 'https://sv0.map.qq.com/hlrender',
        });
    },

    // 初始化腾讯全景按钮
    _initTencentPanoCtrl(map: any) {
        this.options.TencentPanoCtrl = new g2.control.TencentPanoramaControl({
            map: this.map,
            heading: 40,
            pitch: 6,
            offset: [-10, -40],
            navigationControl: false,
            cancel: false,
        });
    },

    // 初始化百度全景覆盖图层
    _initPanoCoverageLayer() {
        const panoLayer = new g2.carto.BDPanoCoverageLayer({
            name: '百度全景覆盖图层',
            id: 'baiduPanoCoverageLayer',
            visible: true,
            opacity: 1,
            zIndex: 10,
            projection: 'baidu',
        });
        return panoLayer;
    },

    // 初始化百度全景按钮
    _initbdPanoCtrl(map: any) {
        const bdPanoCtrl = new g2.control.BaiduPanoramaControl({
            map: this.map,
            heading: 40,
            pitch: 6,
            navigationControl: false,
            linksControl: false,
            offset: [-10, -40],
            // cancel: false,
        });
        return bdPanoCtrl;
    },
    // 移除百度街景覆盖范围图层与按钮
    removebduLayerCtro() {
        // 移除百度图层
        const panoCoverageLayerRe = this.map.findLayer('baiduPanoCoverageLayer');
        if (!!panoCoverageLayerRe) {
            this.map.removeLayer(panoCoverageLayerRe);
        }
        this.map.removePanoramaControl(this.options.bdPanoCtrl);
    },
    // 移除百度街景覆盖范围图层与按钮
    removeTencentLayerCtro() {
        // 移除百度图层
        const panoCoverageLayerRe = this.map.findLayer('tencentPanoCoverageLayer');
        if (!!panoCoverageLayerRe) {
            this.map.removeLayer(panoCoverageLayerRe);
        }
        this.map.removePanoramaControl(this.options.TencentPanoCtrl);
    },
});

export default component;
